// TODO: update Ad API in fly-listings to be compatible with this implementation
// so we can reuse that component instead of having to maintain both
import React from 'react'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import isFunction from 'lodash/isFunction'
import { SponsoredAd } from './SponsoredAd/SponsoredAd'
import { StandardAd } from './StandardAd/StandardAd'
import { InlineAd } from './InlineAd/InlineAd'
import { ADS_INFO } from './constants'
import { isServerSide } from '../../util/isServerSide'

class Ad extends React.Component {
  constructor(props) {
    super(props)
    if (isServerSide) {
      return
    }
    if (window?.googletag?.cmd) {
      window.googletag.cmd.push(function () {
        // TODO: future README
        // this does not work with Google Programmable Ads (GPA)
        // the size is critical here, if it is wrong, enableSingleRequest will not work
        window.googletag.pubads().enableSingleRequest()

        window.googletag.enableServices()
      })
    }

    this.state = {
      deviceType: this.getDeviceType(),
      shown: false,
      stickyHeader: false,
    }

    this.getClassName = () => {
      const { className } = this.props
      let adClassName = className || 'desktop-only-show ad'

      if (this.state.stickyHeader) {
        adClassName = adClassName + ' sticky-search-header-ad'
      }

      return adClassName
    }

    this.throttledUpdateDimensions = throttle(() => {
      this.setState((prevState) => {
        const newDeviceType = this.getDeviceType()
        if (prevState.deviceType !== newDeviceType) {
          if (!prevState.shown) {
            prevState.shown = true
            this.publishAd()
            this.refreshAds()
            if (window?.googletag?.cmd) {
              window.googletag.cmd.push(() => {
                window.googletag.display(this.props.adId)
              })
            }
          } else {
            this.refreshAds()
          }
          return {
            deviceType: newDeviceType,
            state: prevState.shown,
          }
        }
        return prevState
      })
    }, 250)
  }

  publishAd(tryToLoad = false) {
    const { adId, inlineAds } = this.props
    const adObj = ADS_INFO[adId]
    const { adUnitPath: defaultAdUnitPath, adSize } = adObj

    const adUnitPath = defaultAdUnitPath

    // Short circuit if trying to load and isnt above min-width
    if (tryToLoad) {
      const minWidth = adObj.minWidth || 0
      const maxWidth = adObj.maxWidth || Infinity
      const currentWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0

      if (currentWidth < minWidth || currentWidth > maxWidth) {
        return
      }
    }

    if (window?.googletag?.cmd) {
      window.googletag.cmd.push(() => {
        if (!this.slot) {
          // Check GPT registry for a pre-existing slot before attempting defineSlot.
          // On re-mount after filter removal, the slot remains registered in GPT even
          // though this component instance is new and this.slot is null.
          const existingSlot = window.googletag
            .pubads()
            ?.getSlots?.()
            ?.find((s) => s.getSlotElementId() === adId)

          if (existingSlot) {
            // Slot was pre-registered — recover the reference and flag for refresh
            this.slot = existingSlot
            this.slotNeedsRefresh = true
          } else {
            // the size is critical here, if it is wrong, enableSingleRequest will not work
            this.slot = window.googletag.defineSlot(adUnitPath, adSize, adId)
            this.slotNeedsRefresh = false

            if (!this.slot) {
              return false
            }
          }
        }

        // Reponsive size mapping
        const mapping = window.googletag.sizeMapping()
        this.addGoogleTagMapping(mapping, 0, adObj)
        this.addGoogleTagMapping(mapping, 1280, adObj)
        const builtMap = mapping.build()
        this.slot.defineSizeMapping(builtMap)

        // Define targets
        const targets = !inlineAds ? this.buildGptDartAdTargets() : this.buildGptDartAdTargetsInline()
        targets.forEach((target) => {
          this.slot.setTargeting(target.key, target.value)
        })

        // Custom targets
        this.addCustomTargeting(adObj, this.slot)

        // Add publish service
        this.slot.addService(window.googletag.pubads())

        // Publish
        window.googletag.pubads()

        return true
      })
    }
  }

  addCustomTargeting(adObj, slot) {
    const targets = adObj.setTargeting
    if (targets instanceof Array) {
      targets.forEach((target) => {
        slot.setTargeting(target[0], target[1])
      })
    }
  }

  addGoogleTagMapping(mappingObj, minWidth, adObj) {
    if (adObj[minWidth]) {
      mappingObj.addSize([minWidth, 0], adObj[minWidth])
    }
  }

  buildGptDartAdTargets() {
    let targets = []
    const PCLN_BOOTSTRAP_DATA = this.props.pclnBootstrapData
    const slices = get(PCLN_BOOTSTRAP_DATA, 'searchRequest.slices')
    const airports = get(PCLN_BOOTSTRAP_DATA, 'searchRequest.airports')
    const refId =
      get(PCLN_BOOTSTRAP_DATA, 'requestLocals.referral.sourceId', '') +
      get(PCLN_BOOTSTRAP_DATA, 'requestLocals.referral.id', '')

    if (slices && slices.length && airports) {
      // Get the params from url
      const origin = slices[0].originAirport
      const destination =
        slices.length > 1 ? slices[slices.length - 1].originAirport : slices[0].destinationAirport

      // Get the data from params
      const originData = airports[origin]
      const destinationData = airports[destination]

      // Get the city code
      const depcity = originData.cityCode
      const retcity = destinationData.cityCode

      // Get the airport code
      const oairport = slices[0].route_airport
        ? slices[0].route_airport.split('-')[0]
        : originData.airportCode
      const dairport = slices[0].route_airport
        ? slices[0].route_airport.split('-')[1]
        : destinationData.airportCode

      // Set as targets
      targets = [
        {
          key: 'depcity',
          value: depcity,
        },
        {
          key: 'retcity',
          value: retcity,
        },
        {
          key: 'oairport',
          value: oairport,
        },
        {
          key: 'dairport',
          value: dairport,
        },
        {
          key: 'route_airport',
          value: slices[0].route_airport ? slices[0].route_airport : `${oairport}-${dairport}`.toUpperCase(),
        },
        {
          key: 'route_city',
          value: slices[0].route_city ? slices[0].route_city : `${depcity}-${retcity}`.toUpperCase(),
        },
        {
          key: 'refid',
          value: refId,
        },
      ]
    }

    return targets
  }

  buildGptDartAdTargetsInline() {
    const { departingFrom, returningFrom, searchReferralId } = this.props
    let targets = []

    if (departingFrom && returningFrom) {
      targets = [
        {
          key: 'depcity',
          value: departingFrom.cityCode,
        },
        {
          key: 'retcity',
          value: returningFrom.cityCode,
        },
        {
          key: 'oairport',
          value: departingFrom.airportCode,
        },
        {
          key: 'dairport',
          value: returningFrom.airportCode,
        },
        {
          key: 'refid',
          value: searchReferralId,
        },
      ]
    }

    return targets
  }

  refreshAds() {
    if (window?.googletag?.cmd && window.googletag.pubads && this.slot) {
      const adService = window.googletag.pubads()

      if (isFunction(adService.refresh)) {
        adService.refresh([this.slot])
      }
    }
  }

  getDeviceType() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0

    let deviceType
    if (width < 840) {
      deviceType = 'hidden'
    } else if (width >= 1280) {
      deviceType = 'larger'
    } else {
      deviceType = 'smaller'
    }

    return deviceType
  }

  componentDidMount() {
    if (isServerSide) {
      return
    }
    window.addEventListener('resize', this.throttledUpdateDimensions)

    const { adId } = this.props

    this.publishAd()

    if (window?.googletag?.cmd) {
      window.googletag.cmd.push(() => {
        if (this.slotNeedsRefresh) {
          // Re-mount: publishAd() found a pre-existing slot in GPT's registry
          this.refreshAds()
        } else {
          // First mount: publishAd() defined the slot fresh via defineSlot()
          window.googletag.display(adId)
        }
      })
    }

    this.props.pushAd(adId)
  }

  componentWillUnmount() {
    if (isServerSide) {
      return
    }
    window.removeEventListener('resize', this.throttledUpdateDimensions)
  }

  render() {
    if (isServerSide) {
      return
    }
    const {
      inlineAds,
      isSponsored,
      adId,
      gaIndex,
      listingsLastUpdateTime,
      minScreenSize,
      isSticky,
      marginBottom,
      fitWidth,
    } = this.props
    if (isSponsored) {
      return <SponsoredAd adId={adId} gaIndex={gaIndex} />
    }
    if (inlineAds) {
      return <InlineAd gaIndex={gaIndex} adId={adId} className={this.getClassName()} />
    }
    return (
      <StandardAd
        className={this.getClassName()}
        listingsLastUpdateTime={listingsLastUpdateTime}
        minScreenSize={minScreenSize}
        isSticky={isSticky}
        adId={adId}
        marginBottom={marginBottom}
        fitWidth={fitWidth}
      />
    )
  }
}

export { Ad }
